export default function initScrollToTop() {
    const scrollButton = document.querySelector('.scrollToTop')
    if (scrollButton) {
        const header = document.querySelector('header')
        const observerConfig = {
            rootMargin: "0px",
            threshold: 1
        }
        const observerCallback = (entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    scrollButton.classList.add('hidden')
                } else {
                    scrollButton.classList.remove('hidden')
                }
            })
        }
        const headerObserver = new IntersectionObserver(observerCallback, observerConfig)
        headerObserver.observe(header)
    }
}